module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.state.name) + "\n\t")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title mb-3"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.state.total) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "state-box-container"
  }, [_c('div', {
    staticClass: "state-box-background",
    style: (("background-color: " + (_vm.state.color) + ";\n\t\t\t\theight: " + _vm.backgroundHeight + "%"))
  }, [_c('span', {
    staticClass: "number",
    style: (("color: " + (_vm.state.color)))
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.state.value) + "\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdc95296","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/StateBox.vue
// module id = 1704
// module chunks = 18